/**
 * 피처 플래그 상수 정의
 * 
 * 사용자 역할 기반, 퍼센트 기반 롤아웃, 또는 단순 boolean 플래그를 지원합니다.
 */

/** 사용자 역할 타입 (JWT claims에서 사용되는 역할) */
export type UserRole = "guest" | "user";

/**
 * 피처 플래그 규칙 타입
 * 
 * - percentageOfUsers: 사용자의 N%에게 피처를 활성화
 * - userRoles: 특정 역할을 가진 사용자에게 피처를 활성화
 */
export type FeatureFlagRule = {
    /** 피처를 활성화할 사용자 비율 (0.0 ~ 1.0) */
    percentageOfUsers?: number;
    /** 피처를 활성화할 사용자 역할 목록 */
    userRoles?: UserRole[];
} & (
    | {
          percentageOfUsers: number;
      }
    | { userRoles: UserRole[] }
);

/**
 * 피처 플래그 정의
 * 
 * boolean: 모든 사용자에게 켜짐/꺼짐
 * FeatureFlagRule: 단일 규칙
 * FeatureFlagRule[]: 여러 규칙 (OR 조건 - 하나라도 만족하면 활성화)
 * 
 * @note Chrome extension 빌드 시 환경 변수로 fallback 값을 설정할 수 있습니다:
 * - EXTENSION_FALLBACK_FEATURE_FLAG_CHRISTMAS_EVENT
 * - EXTENSION_FALLBACK_FEATURE_FLAG_SHOW_VOTING_CARD
 */
export const FEATURE_FLAGS: Record<string, FeatureFlagRule[] | FeatureFlagRule | boolean> = {
    // ===== 크리스마스 관련 피처 =====
    /** 크리스마스 이벤트 (헤더 기프트박스 등) */
    CHRISTMAS_EVENT: process.env.EXTENSION_FALLBACK_FEATURE_FLAG_CHRISTMAS_EVENT === 'true',

    // ===== 투표 관련 피처 =====
    /** 투표 카드 표시/숨김 */
    SHOW_VOTING_CARD: process.env.EXTENSION_FALLBACK_FEATURE_FLAG_SHOW_VOTING_CARD === 'true',

    // ===== 테스트용 플래그 =====
    /** 개발/테스트용 플래그 */
    DEV_ONLY_FEATURE: false,
};

/** 피처 플래그 이름 타입 (자동 생성) */
export type FeatureFlagName = keyof typeof FEATURE_FLAGS;
